class Canvas {
  constructor(e) {
    this.images = e.images;
    this.container = e.container;
    this.cover = e.cover;
    this.displayIndex = 0;

    this.body = document.querySelector('body');
    this.imagesite = document.querySelector('.imagesite-container');
    this.wpadminbar = document.querySelector('#wpadminbar');
    this.cHeight = this.imagesite.offsetHeight;
    this.bTop = this.wpadminbar ? this.body.getBoundingClientRect().top - 32 : this.body.getBoundingClientRect().top;
    this.iTop = this.imagesite.getBoundingClientRect().top;

    this.scroller();
  }

  setup() {
    this.canvas = document.createElement("canvas");
    this.canvas.classList.add("imagesite-container__canvas");
    this.container.prepend(this.canvas);
    this.ctx = this.canvas.getContext('2d')

    window.addEventListener('resize', () => this.resize());
    this.resize();
  }

  renderIndex(e) {
    if (this.images[e]) {
        return this.drawImage(e);
    }
    // Find closest loaded image
    for (var t = Number.MAX_SAFE_INTEGER, r = e; r >= 0; r--)
        if (this.images[r]) {
            t = r;
            break
        }
    for (var n = Number.MAX_SAFE_INTEGER, i = e, o = this.images.length; i < o; i++)
        if (this.images[i]) {
            n = i;
            break
        }
    this.images[t] ? this.drawImage(t) : this.images[n] && this.drawImage(n)
  }

  drawImage(e) {
    this.displayIndex = e;
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    const img = this.images[this.displayIndex];
    const canvasRatio = this.canvas.width / this.canvas.height;
    const imageRatio = img.naturalWidth / img.naturalHeight;

    let drawWidth, drawHeight, x, y;

    if (this.cover) {
        this.drawImageCover(this.ctx, img);
    } else {
        // Berechne die Dimensionen, um das Bild zentriert und in voller Qualität darzustellen
        if (canvasRatio > imageRatio) {
            // Canvas ist verhältnismäßig breiter als das Bild
            drawHeight = this.canvas.height;
            drawWidth = drawHeight * imageRatio;
        } else {
            // Canvas ist verhältnismäßig höher als das Bild
            drawWidth = this.canvas.width;
            drawHeight = drawWidth / imageRatio;
        }

        // Zentriere das Bild
        x = (this.canvas.width - drawWidth) / 2;
        y = (this.canvas.height - drawHeight) / 2;

        // Zeichne das Bild in Originalqualität
        this.ctx.drawImage(img, x, y, drawWidth, drawHeight);
    }
  }

  resize() {
    // Viewport Dimensionen
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    // Canvas-Größe an Viewport anpassen
    this.canvas.width = vw;
    this.canvas.height = vh;
    this.canvas.style.width = `${vw}px`;
    this.canvas.style.height = `${vh}px`;

    this.renderIndex(this.displayIndex);
  }

  /**
 * By Ken Fyrstenberg Nilsen
 *
 * drawImageProp(context, image [, x, y, width, height [,offsetX, offsetY]])
 *
 * If image and context are only arguments rectangle will equal canvas
*/
  drawImageCover(ctx, img, x, y, w, h, offsetX, offsetY) {

      if (arguments.length === 2) {
          x = y = 0;
          w = ctx.canvas.width;
          h = ctx.canvas.height;
      }

      // default offset is center
      offsetX = typeof offsetX === "number" ? offsetX : 0.5;
      offsetY = typeof offsetY === "number" ? offsetY : 0.5;

      // keep bounds [0.0, 1.0]
      if (offsetX < 0) offsetX = 0;
      if (offsetY < 0) offsetY = 0;
      if (offsetX > 1) offsetX = 1;
      if (offsetY > 1) offsetY = 1;

      var iw = img.width,
          ih = img.height,
          r = Math.min(w / iw, h / ih),
          nw = iw * r,   // new prop. width
          nh = ih * r,   // new prop. height
          cx, cy, cw, ch, ar = 1;

      // decide which gap to fill
      if (nw < w) ar = w / nw;
      if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
      nw *= ar;
      nh *= ar;

      // calc source rectangle
      cw = iw / (nw / w);
      ch = ih / (nh / h);

      cx = (iw - cw) * offsetX;
      cy = (ih - ch) * offsetY;

      // make sure source rectangle is valid
      if (cx < 0) cx = 0;
      if (cy < 0) cy = 0;
      if (cw > iw) cw = iw;
      if (ch > ih) ch = ih;

      // fill image in dest. rectangle
      ctx.drawImage(img, cx, cy, cw, ch,  x, y, w, h);
  }

  scrollFunction(e){
    let rTop = this.bTop - this.iTop < 0 ? -1 * (this.bTop - this.iTop) : this.bTop - this.iTop;
    let boundingQuote = document.querySelector('.ns-quote').getBoundingClientRect();
    let qbTop = boundingQuote.top;

    if(window.scrollY - rTop < 0){
      this.canvas.style.position = 'fixed';
      this.canvas.style.top = '0';
    } else if(pageYOffset + qbTop <= window.scrollY + 550) {
      this.canvas.style.position = 'fixed';
      this.canvas.style.top = '0';
    } else{
      this.canvas.style.position = 'fixed';
      this.canvas.style.top = '0';
    }
  }

  scroller(){
    window.addEventListener('scroll', (e) => {
      this.scrollFunction(e);
    });
    window.addEventListener('touchmove', (e) => {
      this.scrollFunction(e);
    });
  }
} export default Canvas;
